export default __webpack_public_path__ + "static/media/explore.fcd5d8ee.svg";